import React from "react";
import PropTypes from "prop-types";
import { exhibitionShape, eventShape } from "../shapes";

function Event({ event: { short_name: shortName, date, time, slug } }) {
  return (
    <article className="m-related-record a-bg-white">
      <header className="m-related-record__header">
        <p className="m-related-record__title">{shortName}</p>
        <div className="m-related-record__footer">
          <p className="m-related-record__meta">
            {date}
            <br />
            {time}
          </p>
          <a href={`/events/${slug}`} className="m-related-record__link">
            Learn More
          </a>
        </div>
      </header>
    </article>
  );
}

Event.displayName = "ExhibitionsLanding.Current.RelatedEventList.Event";

Event.propTypes = {
  event: PropTypes.shape(eventShape).isRequired,
};

function RelatedEventList({ exhibition: { events } }) {
  if (!events || events.length <= 0) return null;

  return events
    .slice(0, 2)
    .map((event) => <Event key={event.id} event={event} />);
}

RelatedEventList.propTypes = {
  exhibition: PropTypes.shape(exhibitionShape).isRequired,
};

RelatedEventList.displayName = "ExhibitionsLanding.Current.RelatedEventList";

export default RelatedEventList;
